"use client";

import { useState } from "react";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Do I need any prior AI or Tech experience?",
      answer:
        "Not at all. This workshop is beginner-friendly and designed for anyone who wants to learn AI from scratch.",
    },
    {
      question:
        "How can ChatGPT help me save time and resources in my business operations?",
      answer:
        "ChatGPT saves time and resources by automating content creation, customer support, and data analysis.",
    },
    {
      question:
        "Can I expect hands-on training and practical examples during the workshop?",
      answer:
        "Yes, the workshop includes hands-on training with practical examples.",
    },
    {
      question: "Who should attend this workshop?",
      answer:
        "This workshop is designed for professionals of all levels and industries who want to harness the power of AI and ChatGPT to enhance their professional skills and success.",
    },
    {
      question: "Will I receive a certificate upon completion?",
      answer:
        "Absolutely! You'll get a virtual certificate signed by your mentor, verifying your completion of the course. It's a tangible way to showcase your newly acquired skills and expertise.",
    },
    {
      question:
        "How can I stay up to date on future developments, workshops, and courses related to ChatGPT?",
      answer:
        "Stay updated through our newsletter, website, and social media channels.",
    },
    {
      question: "Will this be live or pre-recorded?",
      answer:
        "No, this is not a live session, but even better than that!\n\nHere's why: This is an Interactive GrowthSchool experience in which you will be learning practical concepts taught by your mentor. You will be attending this stream with like-minded doers like you, while participating in polls, answering thought-provoking questions, attempting quizzes, and doing many more exciting activities. By the end of the value-packed session, you will have a roadmap to reach your desired outcomes 🚀",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-10 md:py-16">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <p className="text-[#0A0A0A] text-sm md:text-base font-normal uppercase mb-2">
            MORE QUESTIONS?
          </p>
          <h2 className="text-[#002726] text-[28px] md:text-[36px] font-medium mb-3">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-gray-300 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left hover:bg-gray-50 transition-colors"
              >
                <p className="text-[#041B01] text-base md:text-lg font-medium pr-4">
                  {faq.question}
                </p>
                <svg
                  className={`w-5 h-5 flex-shrink-0 text-[#041B01] transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4 md:pb-6">
                  <p className="text-[#041B01] text-sm md:text-base font-normal leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
